var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-router-wrapper"},[_c('top-navbar',{staticClass:"navbar-wrapper"}),_c('div',{staticClass:"app-bottom-content-wrapper"},[(_vm.adminPanel === false && _vm.isAuditor === false)?_c('side-bar',{staticClass:"side-bar-wrapper",class:{
          'side-bar-flex': _vm.navbarState,
        }}):_vm._e(),(_vm.adminPanel === false && _vm.isAuditor === true)?_c('auditor-sidebar',{staticClass:"side-bar-wrapper",class:{
          'side-bar-flex': _vm.navbarState,
        }}):_vm._e(),_c('dashboard-content',{staticClass:"app-main-content",class:{
          'dashboard-on-admin-panel': _vm.adminPanel,
          'app-main-content-flex': _vm.navbarState
        },style:({
          'padding': _vm.adminPanel ? `0 !important` : `1em 2.5em`,
        })})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }